document.addEventListener('DOMContentLoaded', function () {
  const productForm = document.querySelector('product-form');

  if (!productForm) return;

  /*
   * Shopify can replace the variant/size picker after a size change.
   * Always look up the current size selector instead of keeping a
   * reference to the original DOM node.
   */
  function getSizeSelector() {
    return document.querySelector('.product-form__input--pill');
  }

  if (!getSizeSelector()) return;


  /* =====================================================
     SIZE / SIZE GUIDE HEADER
     ===================================================== */

  function createSizeGuideHeader() {
    const sizeSelector = getSizeSelector();
    if (!sizeSelector) return;

    /*
     * If Shopify has re-rendered the picker, the old header may have
     * disappeared. Only skip insertion when the header is still
     * directly attached to the current size selector.
     */
    const previous = sizeSelector.previousElementSibling;

    if (
      previous &&
      previous.classList.contains('pg-size-guide-header')
    ) {
      return;
    }

    const oldHeaders = document.querySelectorAll(
      '.pg-size-guide-header'
    );

    oldHeaders.forEach(function (header) {
      if (header.parentNode !== sizeSelector.parentNode) {
        header.remove();
      }
    });

    const header = document.createElement('div');

    header.className = 'pg-size-guide-header';

    header.innerHTML = `
      <span class="pg-size-title">SIZE</span>

      <button
        type="button"
        class="pg-size-guide-link"
      >
        SIZE GUIDE
      </button>
    `;

    sizeSelector.parentNode.insertBefore(header, sizeSelector);


    /* ===================================================
       SIZE / SIZE GUIDE STYLE
       =================================================== */

    const style = document.createElement('style');

    style.textContent = `

      .pg-size-guide-header {
        width: 100%;

        display: flex;
        align-items: center;
        justify-content: space-between;

        margin: 18px 0 0;
        padding: 0;

        box-sizing: border-box;

        font-size: 11px;
        font-weight: 400;
        line-height: 1.3;
        letter-spacing: 0.01em;

        color: rgba(0, 0, 0, 0.55);
      }


      .pg-size-title {
        display: block;

        color: rgba(0, 0, 0, 0.55);

        font-size: 11px;
        font-weight: 400;
      }


      .pg-size-guide-link {
        display: block;

        background: transparent !important;
        border: 0 !important;

        padding: 0 !important;
        margin: 0 !important;

        font-family: inherit;

        color: rgba(0, 0, 0, 0.55) !important;

        font-size: 11px;
        font-weight: 400;

        line-height: 1.3;

        text-decoration: underline !important;
        text-decoration-thickness: 1px;
        text-underline-offset: 2px;

        cursor: pointer;

        transition: opacity 0.15s ease;
      }


      .pg-size-guide-link:hover {
        opacity: 0.7;
      }


      /* Keep the size boxes underneath the header */

      .product-form__input--pill {
        margin-top: 12px !important;
      }

    `;

    document.head.appendChild(style);


    /* ===================================================
       SIZE GUIDE CLICK
       =================================================== */

    const sizeGuideLink = header.querySelector(
      '.pg-size-guide-link'
    );

    if (sizeGuideLink) {

      sizeGuideLink.addEventListener('click', function () {

        /*
         * Find the existing Size Guide accordion.
         * We do NOT open a separate page.
         */

        const detailItems = document.querySelectorAll(
          '.pg-product-details .pg-detail-item'
        );

        let sizeGuide = null;

        detailItems.forEach(function (item) {

          const title = item.querySelector(
            '.pg-detail-title'
          );

          if (
            title &&
            title.textContent.trim().toLowerCase() ===
              'size guide'
          ) {
            sizeGuide = item;
          }

        });


        if (!sizeGuide) return;


        /*
         * Open the existing Size Guide accordion.
         */

        sizeGuide.open = true;


        /*
         * Scroll smoothly to the Size Guide section.
         *
         * 90px offset leaves space for the fixed header.
         */

        setTimeout(function () {

          const headerOffset = 90;

          const position =
            sizeGuide.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset;

          window.scrollTo({
            top: position,
            behavior: 'smooth'
          });

        }, 50);

      });

    }

  }


  /* =====================================================
     CREATE SIZE / SIZE GUIDE HEADER
     ===================================================== */

  createSizeGuideHeader();

  /*
   * Shopify may replace the variant picker when the selected size
   * changes. Recreate the Size / Size Guide header after that
   * re-render. The observer is limited to the product form.
   */
  const sizeHeaderObserver = new MutationObserver(function () {
    createSizeGuideHeader();
  });

  sizeHeaderObserver.observe(productForm, {
    childList: true,
    subtree: true
  });


  /* =====================================================
     GET CURRENT ADD TO CART BUTTON
     ===================================================== */

  function getButton() {
    return productForm.querySelector(
      '.product-form__submit'
    );
  }


  function getButtonText() {
    const button = getButton();

    return button
      ? button.querySelector('span')
      : null;
  }


  /* =====================================================
     BUTTON STYLE
     ===================================================== */

  function makeButtonBlack() {

    const button = getButton();

    if (!button) return;

    button.style.setProperty(
      'background-color',
      '#402210',
      'important'
    );

    button.style.setProperty(
      'color',
      '#ffffff',
      'important'
    );

    button.style.setProperty(
      'border-color',
      '#402210',
      'important'
    );

    button.style.setProperty(
      'opacity',
      '1',
      'important'
    );

  }


  /* =====================================================
     SELECT SIZE STATE
     ===================================================== */

  function showSelectSize() {

    const button = getButton();
    const text = getButtonText();

    if (!button || !text) return;

    button.disabled = true;

    text.textContent = 'SELECT SIZE';

    makeButtonBlack();

  }


  /* =====================================================
     ADD TO CART STATE
     ===================================================== */

  function showAddToCart() {

    const button = getButton();
    const text = getButtonText();

    if (!button || !text) return;

    button.disabled = false;

    text.textContent = 'ADD TO CART';

    makeButtonBlack();

  }


  /* =====================================================
     INITIAL STATE
     ===================================================== */

  const sizeSelector = getSizeSelector();

  if (!sizeSelector) return;

  const sizeInputs = sizeSelector.querySelectorAll(
    'input[type="radio"]'
  );

  if (!sizeInputs.length) return;


  /*
   * Remove Shopify's initial selected size.
   * We only do this once when the page loads.
   */

  sizeInputs.forEach(function (input) {
    input.checked = false;
  });


  showSelectSize();


  /* =====================================================
     NATIVE SIZE CHANGE
     ===================================================== */

  /*
   * Use event delegation so this continues working
   * even if Shopify updates the variant form.
   */

  document.addEventListener('change', function (event) {

    const input = event.target;


    if (
      !input.matches(
        '.product-form__input--pill input[type="radio"]'
      )
    ) {
      return;
    }


    if (input.disabled || !input.checked) return;


    /*
     * Change the button immediately.
     */

    showAddToCart();


    /*
     * Shopify updates the variant ID after the
     * change event. Re-apply the visual state once
     * the native variant update has completed.
     */

    setTimeout(function () {

      showAddToCart();

    }, 0);

  });


  /* =====================================================
     KEEP SELECT SIZE BLACK
     ===================================================== */

  const style = document.createElement('style');


  style.textContent = `

    .product-form__submit:disabled {

      background-color: #402210 !important;

      color: #ffffff !important;

      border-color: #402210 !important;

      opacity: 1 !important;

    }


    .product-form__submit:disabled span {

      color: #ffffff !important;

    }


    .product-form__input--pill
    input[type="radio"] + label {

      pointer-events: auto !important;

      cursor: pointer !important;

    }

  `;


  document.head.appendChild(style);

});